<template>
  <section v-if="blok" v-editable="blok" title-accordion :data-spacing="blok.spacing || 'boxed'">
    <div class="container">
      <div class="row">
        <div class="section-content">
          <div v-if="blok.header" class="section-header" v-html="blok.header"></div>
          <h2 v-if="blok?.title && title != ''" class="section-title" v-html="title"></h2>
          <div v-if="blok?.description && description != ''" class="section-description" v-html="description"></div>
        </div>
        <div class="section-accordion">
          <div class="accordion-card">
            <AccordionItem v-for="(item, i) in blok.accordion" :key="item._uid" v-model="active" :blok="item" :open="active === i" :value="i" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
  import type { AccordionItem } from "~/types/storyblok";
  const props = defineProps({ blok: Object });

  const title = computed(() => useRichText(props?.blok?.title || {}));
  const description = computed(() => useRichText(props?.blok?.description || {}));

  const active = ref(0);

  const defineQuestions = computed(() => {
    return props.blok?.accordion
      .map((item: AccordionItem) => {
        if (!(item.title && item.title.endsWith("?"))) return null;
        const content = computed(() => useRichText(item?.content || {}));

        if (content.value && content.value.length === 0) return null;

        return defineQuestion({
          name: item.title,
          acceptedAnswer: stripTags(content.value || ""),
        });
      })
      .filter(Boolean);
  });

  if (defineQuestions.value.length > 0) {
    useSchemaOrg([
      defineWebPage({
        "@type": "FAQPage",
      }),
      ...defineQuestions.value,
    ]);
  }
</script>
<style src="~/assets/scss/section/title-accordion.scss" lang="scss"></style>
